import React from "react";
import { TabMenu } from "primereact/tabmenu";
import PropTypes from "prop-types";
// import { useState } from "react";
// import Footer from "../../../Footer/Footer";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import { ScrollPanel } from "primereact/scrollpanel";
import { findItemInEditManagementVisibility } from "Services/functions";
import "./NavBarTab.scss";

const NavBarTab = (props) => {
  const { items, select, handleMenu } = props;
  const itemsAnnuaireVisible = [];
  items.itemsAnnuaire?.map((itemAnnuaire) => {
    if (
      findItemInEditManagementVisibility(
        itemAnnuaire?.data,
        props.editManagementBoolean
      )
    ) {
      itemsAnnuaireVisible.push(itemAnnuaire);
    }
  });
  return (
    <div className="styleNavBarActive" id={props.id}>
      <div className="navBarProfil">
        {select == "annuaire" && itemsAnnuaireVisible.length > 1 && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={itemsAnnuaireVisible}
              activeIndex={itemsAnnuaireVisible.findIndex(
                (v) => v.label == props.items.activeItemAnnuaire.label
              )}
              onTabChange={(e) => {
                props.handleMenu({
                  activeItemAnnuaire: itemsAnnuaireVisible.find(
                    (item) => item.label === e.value.label
                  ),
                });
              }}
            />
          </ScrollPanel>
        )}
        {select == "profiledit" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsProfilEdit}
              activeIndex={items.activeItemProfilEdit}
              onTabChange={(e) =>
                handleMenu({
                  activeItemProfilEdit: items.itemsProfilEdit.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "profil" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsProfil}
              activeIndex={items.activeItemProfil}
              onTabChange={(e) =>
                handleMenu({
                  activeItemProfil: items.itemsProfil.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "cvtheque" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={
                props.auth.isAdmin
                  ? items.itemsCVTheque
                  : items.itemsCVTheque.filter(
                      (item) => item.label != "Paniers de cv"
                    )
              }
              activeIndex={items.activeItemCVTheque}
              onTabChange={(e) =>
                handleMenu({
                  activeItemCVTheque: items.itemsCVTheque.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "depotoffre" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsDepotOffre}
              activeIndex={items.activeItemDepotOffre}
              onTabChange={(e) =>
                handleMenu({
                  activeItemDepotOffre: items.itemsDepotOffre.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "groupes" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsGroupes}
              activeIndex={items.activeItemGroupes}
              onTabChange={(e) =>
                handleMenu({
                  activeItemGroupes: items.itemsGroupes.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "groupesadmin" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsGroupesAdmin}
              activeIndex={items.activeItemGroupesAdmin}
              onTabChange={(e) =>
                handleMenu({
                  activeItemGroupesAdmin: items.itemsGroupesAdmin.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "offre" && props.auth.isAdmin ? (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsOffreAdmin}
              activeIndex={items.activeItemOffre}
              onTabChange={(e) =>
                handleMenu({
                  activeItemOffre: items.itemsOffreAdmin.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        ) : (
          select == "offre" && (
            <ScrollPanel className="navBarProfil__scrollMenu">
              <TabMenu
                className="navBarProfil__tabMenu"
                model={items.itemsOffre}
                activeIndex={items.activeItemOffre}
                onTabChange={(e) =>
                  handleMenu({
                    activeItemOffre: items.itemsOffre.findIndex(
                      (v) => v.label == e.value.label
                    ),
                  })
                }
              />
            </ScrollPanel>
          )
        )}
        {select == "evenement" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsEvenement}
              activeIndex={items.activeItemEvenement}
              onTabChange={(e) =>
                handleMenu({
                  activeItemEvenement: items.itemsEvenement.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "evenementadmin" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsEvenementAdmin}
              activeIndex={items.activeItemEvenementAdmin}
              onTabChange={(e) =>
                handleMenu({
                  activeItemEvenementAdmin: items.itemsEvenementAdmin.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "actu" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsActu}
              activeIndex={items.activeItemActu}
              onTabChange={(e) =>
                handleMenu({
                  activeItemActu: items.itemsActu.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "actuadmin" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsActuAdmin}
              activeIndex={items.activeItemActuAdmin}
              onTabChange={(e) =>
                handleMenu({
                  activeItemActuAdmin: items.itemsActuAdmin.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
        {select == "parametrage" && (
          <ScrollPanel className="navBarProfil__scrollMenu">
            <TabMenu
              className="navBarProfil__tabMenu"
              model={items.itemsParametrage}
              activeIndex={items.activeItemParametrage}
              onTabChange={(e) =>
                handleMenu({
                  activeItemParametrage: items.itemsParametrage.findIndex(
                    (v) => v.label == e.value.label
                  ),
                })
              }
            />
          </ScrollPanel>
        )}
      </div>
    </div>
  );
};

NavBarTab.propTypes = {
  select: PropTypes.string,
  items: PropTypes.object,
  editManagementBoolean: PropTypes.array,
  activeIndex: PropTypes.any,
  setActiveIndex: PropTypes.func,
  handleMenu: PropTypes.func,
  id: PropTypes.string,
  auth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  items: state.items,
  editManagementBoolean: state.admin.editManagementBoolean,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBarTab);
